import { useCallback, useContext, useEffect } from 'react';
import { AppContext } from '../app-context';
import { useCalculatorFinancial } from '../store/calculator/financial';
import { VehicleCategory } from '../types/enums/vehicles';
import { FinancingRatesInterface } from '../types/finance';
import { VehicleDetailsContext } from './details-context';
import { get } from './request';

const useFetchFinancingRates = () => {

    const { vehicle } = useContext(VehicleDetailsContext);
    const { globalApi } = useContext(AppContext);
    const calculatorStore = useCalculatorFinancial();

    const getData = useCallback(() => {
            get(`${globalApi}/volkswagen/cpo-rates`, (data: {data : FinancingRatesInterface, success : boolean}) => {
                calculatorStore.setFinancingRates(data.data);
            });
    }, []);

    useEffect(() => {
        if(!vehicle || vehicle.category == VehicleCategory.NEW) return;
        getData();
    }, [vehicle]);

    useEffect(() => {
        return () => {
            calculatorStore.setFinancingRates(null);
        }
    }, []);
}

export default useFetchFinancingRates;
